import { push } from "connected-react-router";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE,
  APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
  ROUTE_PATH,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION,
  APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE,
  APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE
} from "../../../app/constants";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../../app/errors";
import { ValidateString } from "../../../app/utils";
import { Button, ErrorMark } from "../../../components/RegularComponents";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import {
  setMortgageProperty,
  setAgencyApplicationLicenceSubType
} from "../../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../../TopNavigationBar";
import CheckBoxForm from "../../../components/CheckBoxForm";

export const MainAgentNSLicenceNumber = (props) => {
  const dispatch = useDispatch();
  const { isModal = false, onEditSave = () => {} } = props;
  const { application } = usePathApplication();
  const { agencyApplication } = useSelector(agencyApplicationSelector) || {};
  const isPrincipalBroker = ROUTE_PATH.PB_APP.search(application) !== -1;
  const licencingSubType = agencyApplication
    ? agencyApplication.licencingSubType
    : LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION;
  const applicationMode = APPLICATION_MODE_NEW;

  const propertyKey = "mraNSLicenceNumber";

  const [applicationType, setApplicationType] = useState(
    applicationTypeFromLicenceSubType(licencingSubType)
  );
  const [licenceNumber, setLicenceNumber] = useState(
    agencyApplication?.businessLicenceData?.mraNSLicenceNumber ?? ""
  );
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [showError, setShowError] = useState(false);
  // const [errorString, setErrorString] = useState(null);
  const [confirmCheck1, setConfirmCheck1] = useState(
    agencyApplication?.businessLicenceData?.currentlyMBinBusiness
  );
  const [showValidationError, setShowValidationError] = useState(false);

  const handleSave = () => {
    setApplicationSaveError(false);

    // MRA - 1017 : removing licence number check for now
    // if (0 && !checkLicenceNumber()) {
    //   setLicenceNumberError("licence number needs to be of the format YYYY-1234567");
    //   return;
    // }

    // we don't need below validation for this properly for now.
    if (
      ValidateString(licenceNumber, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR
    ) {
      setShowError(true);
      // setErrorString(ERROR_STRING.LICENCE_NUMBER_EMPTY);
      return false;
    }

    setShowError(false);
    // setErrorString(null);

    if (!confirmCheck1) {
      setShowValidationError(true);
      return false;
    }

    // we need to change the licencingSubType to RETENTION if
    // previous licence number exists.
    if (licenceNumber?.length) {
      if (isPrincipalBroker) {
        setApplicationType(APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE);
        dispatch(
          setAgencyApplicationLicenceSubType(
            LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
          )
        );
      } else {
        setApplicationType(APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE);
        dispatch(
          setAgencyApplicationLicenceSubType(
            LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
          )
        );
      }
    } else {
      if (isPrincipalBroker) {
        setApplicationType(APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE);
        dispatch(
          setAgencyApplicationLicenceSubType(
            LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
          )
        );
      } else {
        setApplicationType(APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE);
        dispatch(
          setAgencyApplicationLicenceSubType(
            LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION
          )
        );
      }
    }

    dispatch(
      setMortgageProperty({
        key: propertyKey,
        value: licenceNumber
      })
    );

    dispatch(
      setMortgageProperty({
        key: "currentlyMBinBusiness",
        value: confirmCheck1
      })
    );

    return true;
  };

  const handleSaveAndNext = () => {
    if (handleSave()) {
      dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        .then((data) => {
          dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_APPLICATION_REVIEW}`));
        })
        .catch((err) => {
          setApplicationSaveError(true);
        });
    }
  };

  const handleSaveAndClose = () => {
    if (handleSave()) {
      onEditSave();
    }
  };

  useCallback(() => {
    setLicenceNumber(agencyApplication?.businessLicenceData?.mraNSLicenceNumber ?? "");
    setApplicationType(applicationTypeFromLicenceSubType(agencyApplication?.licencingSubType));
  }, [agencyApplication, setLicenceNumber, setApplicationType]);

  const handleChange = (e) => {
    setShowError(false);
    setLicenceNumber(e.target.value);
  };

  const title = "Nova Scotia Licence";

  return (
    <div className="container">
      {!isModal && (
        <>
          <TopNavigationBar
            {...props}
            applicationType={applicationType}
            applicationMode={applicationMode}
          />
        </>
      )}

      <div className="row bottomMarginMedium">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div style={{ display: "flex", marginTop: "30px" }}>
            <CheckBoxForm
              id="ns-broker-checkbox-1"
              checked={confirmCheck1}
              value={confirmCheck1}
              labelText={"I am currently a mortgage broker at this brokerage."}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck1(val);
              }}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <div
            className={"ns-fieldset" + (showError ? " has-error ns-fieldset-message-error" : "")}
          >
            <div className="topMarginMedium">
              Enter your current Nova Scotia Mortgage Broker Licence Number
            </div>
            <fieldset className="ns-fieldset">
              {/*showError && (
                <span
                  id={"mortgage-broker-licence-number-text-error"}
                  className="ns-error-message field-validation-error"
                >
                  {errorString}
                </span>
              )*/}
              <input
                type="text"
                className={"fw-25" + (!showError ? " ns-input" : " ns-input--error")}
                id={"mortgage-broker-licence-number-text"}
                name={"mortgage-broker-licence-number-text"}
                value={licenceNumber}
                onChange={handleChange}
              />
            </fieldset>
          </div>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-lg-8">
          <p>If you do not have a current Nova Scotia Mortgage Broker License you can continue.</p>
        </div>
      </div> */}

      {/* Yes/No Answer */}
      <div className="row">
        <div
          className={"col-lg-4" + (applicationSaveError || showValidationError ? " has-error" : "")}
        >
          <Button
            id="current-ns-education-continue-button"
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            text={!isModal ? "Save and next" : "Save and close"}
            onClick={!isModal ? handleSaveAndNext : handleSaveAndClose}
          />
          {applicationSaveError && ErrorMark()}
          {applicationSaveError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
          {(showValidationError || showError) && ErrorMark()}
          {showError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {"Principal Brokers must be designated from mortgage brokers at the brokerage."}
            </div>
          )}
          {showValidationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {
                "You must need to be a Mortgage Broker in the business for which you are applying for."
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
